import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@app/core/services';
import { User } from '@app/entity';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

const PASSWORD_MIN_LEN = 8;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  form: FormGroup;
  user: User;

  apiErrors = {};

  isLoading = false;
  isSuccessfullyChanged: boolean;

  isShowOldPassword: boolean;
  ngUnsubscribe = new Subject();

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      old_password: ['', Validators.required, Validators.minLength(PASSWORD_MIN_LEN)],
      new_password: ['', Validators.required, Validators.minLength(PASSWORD_MIN_LEN)],
      repeat_password: ['', Validators.required, Validators.minLength(PASSWORD_MIN_LEN)],
    });

    this.authService.user
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(user => this.user = user);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  submit() {
    if (this.isLoading) return;

    for (const fieldName of Object.keys(this.form.controls)) {
      this.form.get(fieldName).markAsTouched();
    }

    const newPass = this.form.get('new_password').value;
    const repeatPass = this.form.get('repeat_password').value;

    if (newPass === '' || repeatPass === '' || newPass !== repeatPass) {
      this.apiErrors['non_field_errors'] = 'Пароли не совпадают';
      return;
    }

    this.isLoading = true;
    this.apiErrors = {};
    this.isSuccessfullyChanged = false;

    this.authService.changePassword(this.user, this.form.get('old_password').value, this.form.get('new_password').value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .finally(() => this.isLoading = false)
      .subscribe(successfullyChanged => this.isSuccessfullyChanged = true, error => {
        if (error.status === 400) this.apiErrors = error.error;
        else this.apiErrors['non_field_errors'] = 'Не удалось изменить пароль. Попробуйте снова или обратитесь к администрации портала.';
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/change-password/change-password.component.ts